const news = {
  'news.page.backToTop': 'Back to top',
  'news.page.lastUpdated': 'Last updated: 13 June 2026',
  'news.page.homeLink': 'Home',
  'news.page.currentPage': 'News',

  'news.hero.homeLink': 'Home',
  'news.hero.currentPage': 'News',
  'news.hero.title': 'News',
  'news.hero.titleEn': 'NEWS',
  'news.hero.lead': 'The latest announcements from The Japan Butler Academy — including class schedules, information sessions, and website updates.',
  'news.hero.imgAlt': 'Academy announcements and news',

  'news.list.empty': 'No announcements yet.',
  'news.list.readMore': 'Read More',
  'news.list.allLabel': 'All',
  'news.list.catSchedule': 'Class Schedules',
  'news.list.catSeminar': 'Information Sessions',
  'news.list.catUpdate': 'Updates',
  'news.list.catOther': 'Other',

  'news.faq.label': 'FAQ',
  'news.faq.title': 'Frequently Asked Questions',
  'news.faq.subtitleEn': 'Frequently Asked Questions',
  'news.faq.0.q': 'Where can I find class schedules?',
  'news.faq.0.a': 'We publish all class schedules here as soon as they are confirmed. You can also receive the latest schedule with our free brochure.',
  'news.faq.1.q': 'Do you hold information sessions?',
  'news.faq.1.a': 'Yes — we announce information sessions here as soon as they are scheduled. We also offer a one-day taster session.',
  'news.faq.2.q': 'How often is this page updated?',
  'news.faq.2.a': 'We update this page as developments occur.',

  'news.subscribe.title': 'Stay Informed',
  'news.subscribe.desc': 'Receive the latest class schedules and event announcements with our free brochure.',
  'news.subscribe.btn': 'Request a Free Brochure',

  'news.related.label': 'LEARN MORE',
  'news.related.title': 'Related Pages',
  'news.related.subtitleEn': 'Explore Further',
  'news.related.viewMore': 'Learn More',
  'news.related.0.title': 'Request a Brochure',
  'news.related.0.description': 'Free brochure by email or post',
  'news.related.1.title': 'Courses Overview',
  'news.related.1.description': 'Compare all three courses',
  'news.related.2.title': 'Contact',
  'news.related.2.description': 'Questions and enquiries',
};

export default news;
